import * as actions from './actions'
import * as getters from './getters'
import * as types from './types'

const state = {
    needReload: false,
    reloading: false,
    data: {}
};

const mutations = {
    [types.RELOAD](state, data) {
        state.needReload = true;
    },
    [types.PRE_LOAD](state, data) {
        if (!state.reloading) {
            state.reloading = true;
        }
    },
    [types.POST_LOAD](state, data) {
        state.reloading = false;
        state.needReload = false;
        state.data = data;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
